import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function ProtectedRoute({ children, requireDirector, requireManagement }) {
  const { isAuthenticated, loading, isDirector, isManagement } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500" />
      </div>
    );
  }

  if (!isAuthenticated) {
    // Remember where the staff was headed (e.g. /clock?kt=xxx from a
    // kiosk QR scan) so the login page can send them back after auth
    // instead of dumping them on /dashboard and forcing a re-scan.
    const intended = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to="/login" replace state={{ from: intended }} />;
  }

  if (requireDirector && !isDirector) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requireManagement && !isManagement) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
